import React from 'react';
import {Button, Result, Typography} from "antd";
import {useNavigate} from "react-router-dom";

const ErrorPage = ({ title, description, reset, action }) => {
    const { Title } = Typography;

    const onClickBack = () => {
        
        if (action) {
            reset();
            action();
        }
        
        setTimeout(() => {
            window.location.reload();
        }, 100);
    }

    return (
        <Result
            status='error'
            title={<Title level={1}>{title}</Title>}
            subTitle={<Title type='secondary' level={3}>{description}</Title>}
            extra={<Button type='primary' danger onClick={onClickBack}>
                {title === 'Unauthorized' ? 'Go to Login' : 'Go Back'}
            </Button>}
        />
    )
};

export default ErrorPage;